export default "__VITE_ASSET__DCGqzl67__"